/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Token_InvalidInputs */

const vi_grower_area_camera_token_invalid = /** @type {(inputs: Grower_Area_Camera_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Token chỉ gồm chữ, số, dấu - hoặc _ (tối đa 128 ký tự)`)
};

/**

* @param {Grower_Area_Camera_Token_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_token_invalid = /** @type {((inputs?: Grower_Area_Camera_Token_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Token_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_token_invalid(inputs)
});